module.exports = __webpack_public_path__ + "img/Otto.c03bec14.jpg";